export const TOGGLE_DASHBOARD_SHOULD_REFRESH =
  "TOGGLE_DASHBOARD_SHOULD_REFRESH";
export const TOGGLE_DASHBOARD_LOADING = "TOGGLE_DASHBOARD_LOADING";

/**
 * It will update redux state to recieved parameter
 * @param {boolean} shouldRefresh
 */
export const setShouldRefresh = (shouldRefresh) => ({
  type: TOGGLE_DASHBOARD_SHOULD_REFRESH,
  shouldRefresh,
});

/**
 * It will update redux state to recieved parameter
 * @param {true} loading
 */
export const setLoading = (loading) => ({
  type: TOGGLE_DASHBOARD_LOADING,
  loading,
});
